'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bButton2MThemeNormalPseudoMSizeXsSMNMWidthMaxMToneDefaultDarkRedGreyMViewClassicDefault = (require('./../../button2/button2.react.js').default || require('./../../button2/button2.react.js')).applyDecls();

var _bButton2MThemeNormalPseudoMSizeXsSMNMWidthMaxMToneDefaultDarkRedGreyMViewClassicDefault2 = _interopRequireDefault(_bButton2MThemeNormalPseudoMSizeXsSMNMWidthMaxMToneDefaultDarkRedGreyMViewClassicDefault);

var _bIconMTypeArrowMGlyphCaretsV = (require('./../../icon/icon.react.js'), require('./../../icon/_glyph/icon_glyph.react.js'), (require('./../../icon/_glyph/icon_glyph_carets-v.react.js').default || require('./../../icon/_glyph/icon_glyph_carets-v.react.js')).applyDecls());

var _bIconMTypeArrowMGlyphCaretsV2 = _interopRequireDefault(_bIconMTypeArrowMGlyphCaretsV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'select2',
    elem: 'button',
    render: function render() {
        var block = this.block,
            elem = this.elem,
            _props = this.props,
            val = _props.val,
            view = _props.view,
            tone = _props.tone,
            items = _props.items,
            opened = _props.opened,
            placeholder = _props.placeholder,
            multiselectable = _props.multiselectable,
            buttonProps = _props.buttonProps;


        var id = this.generateId();
        var arrowIconOptions = _extends({}, view === 'default' ? { glyph: 'carets-v' } : { type: 'arrow', direction: opened ? 'top' : 'bottom' }, {
            key: 'arrow',
            mix: { block: block, elem: 'arrow' }
        });

        var icon = void 0;
        items.some(function (item) {
            if (val.indexOf(item.props.val) !== -1 && item.props.icon) {
                icon = _react2.default.cloneElement(item.props.icon, { key: 'icon' });
                return true;
            }
            return false;
        });

        return _react2.default.createElement(_bButton2MThemeNormalPseudoMSizeXsSMNMWidthMaxMToneDefaultDarkRedGreyMViewClassicDefault2.default, _extends({
            innerRef: this.props.setAnchor,
            width: 'max',
            tone: tone,
            view: view,
            mix: { block: block, elem: elem },
            attrs: {
                role: 'listbox',
                'aria-expanded': opened ? 'true' : undefined,
                'aria-labelledby': id,
                'aria-multiselectable': multiselectable ? 'true' : undefined
            },
            textAttrs: { id: id },
            text: placeholder,
            iconLeft: icon,
            iconRight: _react2.default.createElement(_bIconMTypeArrowMGlyphCaretsV2.default, _extends({ key: 'arrow' }, arrowIconOptions))
        }, buttonProps));
    }
});